// @flow
import React, { type Node } from 'react';
import { get, last, find, sum } from 'lodash';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { tracker } from 'angieslist-app-platform';
import { Row, Col } from 'angieslist-react-components';
import CustomerContactsChart from './CustomerContactsChart';
import * as advertiseActions from '../../../../app/common/advertise/advertiseActions';
import './CategoryGroupMetrics.scss';

export type CategoryGroupMetricsProps = {
  singleCategoryMetric: Object,
  serviceProviderId: string,
  user: any,
};

const isLastItem = (currentItem, subCategoryCollection) => (
  currentItem === last(subCategoryCollection)
);

const calculateContactsPercentage = (contactCount, contactTotal) =>
  (contactCount / contactTotal) * 100;


const trackCategory = (segmentDataCollection) => {
  tracker.track('Item Displayed', {
    activityLocation: 'SP : Performance',
    contactCountDisplayed: segmentDataCollection.contactCountDisplayed,
    categoryGroupId: segmentDataCollection.categoryGroupId,
    description: segmentDataCollection.hasAdvertisingIn ? 'Advertising Category Group Contacts' : 'NonAdvertising Category Group Contacts',
    serviceProviderId: segmentDataCollection.serviceProviderId,
    userId: segmentDataCollection.userId,
  });
};

export class CategoryGroupMetricsComponent extends React.Component<CategoryGroupMetricsProps> {
  componentDidMount() {
    const {
      serviceProviderId,
      singleCategoryMetric: {
        aggregatedContactCount,
        categoryGroup: {
          categoryGroupId,
          hasAdvertisingIn,
        },
      },
      user,
    } = this.props;
    const segmentDataCollection = {
      serviceProviderId,
      categoryGroupId,
      contactCountDisplayed: aggregatedContactCount,
      hasAdvertisingIn,
      userId: user.userInfo.response.userId,
    };
    trackCategory(segmentDataCollection);
  }

  props: CategoryGroupMetricsProps;

  render(): Node {
    const {
      singleCategoryMetric,
      serviceProviderId,
    } = this.props;

    const subCategoryCollection = singleCategoryMetric.categoryGroup.categories;

    const typeMetrics = get(singleCategoryMetric, 'contactTypeMetrics', []);

    const callsMetrics = find(typeMetrics, o => o.contactType === 'Calls');
    const estimatedCallsMetrics = find(typeMetrics, o => o.contactType === 'Estimated Calls');
    const quotesMetrics = find(typeMetrics, o => o.contactType === 'RequestAQuote');
    const messagesMetrics = find(typeMetrics, o => o.contactType === 'MessageSent');
    const dealsMetrics = find(typeMetrics, o => o.contactType === 'DealClaimed');

    const callCount = get(callsMetrics, 'contactCount', 0);
    const estimatedCallCount = get(estimatedCallsMetrics, 'contactCount', 0);
    const quoteRequestsCount = get(quotesMetrics, 'contactCount', 0);
    const messagesCount = get(messagesMetrics, 'contactCount', 0);
    const claimedDealsCount = get(dealsMetrics, 'contactCount', 0);

    const totalCount = sum([
      callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount,
    ]);

    // Category Specific Advertise With Us Upsell
    const isAdvertiserInCategory = singleCategoryMetric.categoryGroup.hasAdvertisingIn;

    return (
      <div className="category-group-metrics--wrapper">
        <div className="category-group-component">
          <Row className="category-group-component-header">
            <Col sm={2} className="category-group-component-sub-header hidden-xs">
              <div className="category-group-component-total-contacts-number">
                <h2>{singleCategoryMetric.aggregatedContactCount}</h2>
              </div>
              <div className="category-group-component-total-contacts-subtitle">Contacts</div>
            </Col>
            <Col className="category-group-component-sub-header visible-xs">
              <h3 style={{ marginLeft: '.4em', marginTop: 0 }}>
                {singleCategoryMetric.aggregatedContactCount} Contacts
              </h3>
            </Col>
            <Col sm={10} className="category-group-component-category-info">
              <div style={{ fontWeight: 'bold' }}>
                {singleCategoryMetric.categoryGroup.name}
                <If condition={isAdvertiserInCategory}>
                  <span
                    style={{ fontWeight: 'normal', fontStyle: 'italic' }}
                  >
                    &nbsp;(Advertising)
                  </span>
                </If>
              </div>
              {
                subCategoryCollection.map(subCategoryItem => (
                  isLastItem(subCategoryItem, subCategoryCollection) ?
                    `${subCategoryItem.name}` : `${subCategoryItem.name}, `
                ))
              }
            </Col>
          </Row>
          <Row>
            <Col xs={0} sm={2} >&nbsp;</Col>
            <Col xs={12} sm={10} className="category-group-component-metrics">
              <CustomerContactsChart
                totalToDisplay={singleCategoryMetric ?
                  singleCategoryMetric.aggregatedContactCount : 0
                }
                callsPercentage={calculateContactsPercentage(
                  (callCount + estimatedCallCount),
                  totalCount,
                )}
                trackedCallsPercentage={calculateContactsPercentage(
                  callCount,
                  (callCount + estimatedCallCount),
                )}
                quoteRequestsPercentage={
                  calculateContactsPercentage(quoteRequestsCount, totalCount)
                }
                messagesPercentage={calculateContactsPercentage(messagesCount, totalCount)}
                claimedDealsPercentage={
                  calculateContactsPercentage(claimedDealsCount, totalCount)
                }
                strokeWidth={4}
                serviceProviderId={serviceProviderId}
                isAdvertiser
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default (hot(module)(compose(
  connect(
    state => ({
      advertise: state.advertise,
      user: state.user,
    }),
    advertiseActions,
  ),
  pure,
)(CategoryGroupMetricsComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/CategoryGroupMetrics.js